export const huntPlannerActiveLayerDetails = payload => ({
    type: 'HUNT_PLANNER_ACTIVE_LAYER_DETAILS',
    payload: payload
})